module.exports = __webpack_public_path__ + "static/img/2.4aa563f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/2.png
// module id = JT7f
// module chunks = 0